module.exports = __webpack_public_path__ + "static/img/kp.e28bd59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/kp.png
// module id = 548
// module chunks = 0